import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import ArticleCard from "./ArticleCard";
import SectionLayout from "../common/SectionLayout";
import Breadcrumb from "../common/Breadcrumb";
import { getPublishedArticles } from "../../data/articles";
import { SECTION_TITLES } from "../../config/constants";
import { ArticlesLoadingGrid } from "../common/LoadingSkeleton";

function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading state for better UX
    setLoading(true);
    
    // Get published articles sorted by date (newest first)
    const publishedArticles = getPublishedArticles();
    
    // Small delay to show loading state (remove in production if data loads instantly)
    setTimeout(() => {
      setArticles(publishedArticles);
      setLoading(false);
    }, 300);
  }, []);

  return (
    <SectionLayout className="article-section">
      <Breadcrumb />
      <h1 className="article-heading">
          {SECTION_TITLES.articles.main.split(' ').slice(0, 1).join(' ')} <strong className="purple">{SECTION_TITLES.articles.main.split(' ').slice(1).join(' ')}</strong>
        </h1>
        <p style={{ color: "white" }}>
          {SECTION_TITLES.articles.subtitle}
        </p>
        
        {loading ? (
          <ArticlesLoadingGrid count={6} />
        ) : articles.length === 0 ? (
          <p style={{ color: "white", textAlign: "center", marginTop: "50px" }}>
            No articles published yet. Check back soon!
          </p>
        ) : (
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }} className="content-loaded">
            {articles.map((article, index) => (
              <Col key={index} md={4} className="article-card">
                <ArticleCard article={article} />
              </Col>
            ))}
          </Row>
        )}
    </SectionLayout>
  );
}

export default Articles;